import { apiGetSalaryReportItems } from 'api/reportApi';
import { ItemContainer } from 'components/Print/StyledComps';
import React, { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/store';
import useSalaryPrint from './UsePrintSalary';
import ReactToPrint from 'react-to-print';
import BasicButton from 'components/BasicInputs/BasicButton';

const PrintSalary = ({
    salaryId,
    autoPrint,
}: {
    salaryId?: string | number;
    autoPrint?: boolean;
}) => {
    const dispatch = useAppDispatch();
    const store = useAppSelector((state: any) => state);
    const business = store.businessReducer?.business;
    const [salary, setsalary] = useState<any[] | null>(null);
    const [salaryIsFetched, setsalaryIsFetched] = useState(false);
    const callBack = (salary: any) => {
            setsalary(salary.accounting)
        return setsalaryIsFetched(true);
    };

    const printRef = useRef<any>(null);
    const { contentRef, content } = useSalaryPrint({ salary: salary });

    useEffect(() => {
        if (salaryId) {

            dispatch(apiGetSalaryReportItems({ accountingId: salaryId, callBack }));
        }
    },[]);

    useEffect(() => {
        if (salaryIsFetched && autoPrint) printRef.current.handleClick();
    }, [salaryIsFetched]);

    return (
        <ItemContainer style={{ height: "fit-content", backgroundColor: "white" }}>
            <div className="hidden">{content}</div>
            <ReactToPrint
                ref={printRef}
                trigger={() => (
                    <BasicButton fullWidth variant="outlined">
                        <span>چاپ فیش حقوق</span>
                    </BasicButton>
                )}
                content={() => contentRef.current}
            />
        </ItemContainer>
    );
};

export default PrintSalary;